import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BussinessDocumentsClassEnums, BussinessDocumentsResolutionStatusEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { CostCenterEnums } from 'src/app/enum/cost-center-enums';
import { ElectronicDocumentEnums } from 'src/app/enum/electronic-document-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { InvoiceEnums } from 'src/app/enum/invoice-enums';
import { IvaTypeEnums } from 'src/app/enum/iva-type-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { SettlementTypeEnums } from 'src/app/enum/settlement-type-enums';
import { TypeConceptEnums } from 'src/app/enum/type-concept-enums';
import { TypeDianEnums } from 'src/app/enum/type-dian-enum';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { InvoicesPrintsModel } from 'src/app/models/invoicing/invoices-prints.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SalesRemissionSelectionTableModel } from 'src/app/models/tables/inventory/sales-remission-selection-table.model';
import { InvoiceDetailRegisterModel } from 'src/app/models/tables/invoicing/invoice-detail-register.model';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { SellerService } from 'src/app/services/archive/seller.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { SalesRemissionService } from 'src/app/services/inventory/sales-remission.service';
import { InvoiceDetailService } from 'src/app/services/invoicing/invoice-detail.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsResolutionService } from 'src/app/services/management/bussiness-documents-resolution.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { ListInvoiceConceptComponent } from '../../invoice-concept/list-invoice-concept/list-invoice-concept.component';
import { CopyInvoiceComponent } from '../copy-invoice/copy-invoice.component';
import { InfoInvoiceComponent } from '../info-invoice/info-invoice.component';
import { InvoicePrintingRangeComponent } from '../invoice-printing-range/invoice-printing-range.component';
import { ListInvoiceAttachmentsComponent } from '../list-invoice-attachments/list-invoice-attachments.component';
import { SettlementComponent } from '../settlement/settlement.component';

@Component({
  selector: 'app-register-invoice',
  templateUrl: './register-invoice.component.html',
  styleUrls: ['./register-invoice.component.scss'],
  standalone: false
})
export class RegisterInvoiceComponent implements OnInit {
  @ViewChild('generalDiscount') generalDiscountComponent?: CustomModalComponent | null = null;
  @ViewChild('copyInvoice') copyInvoiceComponent?: CustomModalComponent | null = null;
  @ViewChild('printRange') printRangeComponent?: CustomModalComponent | null = null;
  @ViewChild('invoiceInformation') invoiceInformationComponent?: CustomModalComponent | null = null;
  @ViewChild('attachFileInvoice') attachFileInvoiceComponent?: CustomModalComponent | null = null;
  @ViewChild('settlement') settlementSelectionModalComponent?: CustomModalComponent | null = null;

  activePanel: string = "";
  ascendant: boolean = true;
  ascendantSettlement: boolean = true;
  branchId: number = 0;
  breakpointsForCopy: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };
  bussinessDocumentsTypeId: number = BussinessDocumentsClassEnums.factura;
  bussinessDocumentsTypeIsRental: string = '';
  clientId: number = 0;
  codeCurrency: string = '';
  columnSort: string | null = null;
  companyId: number = 0;
  componentAttachmentsModal = ListInvoiceAttachmentsComponent;
  componentSettlement = SettlementComponent;
  componentGeneralDiscount = ListInvoiceConceptComponent;
  componentAttachFiles = CustomAttachFilesComponent;
  componentInvoiceInformation = InfoInvoiceComponent;
  componentCopyInvoice = CopyInvoiceComponent;
  componentPrintRange = InvoicePrintingRangeComponent;
  columnSortSettlement: string | null = null;
  showAccordion: boolean = false;
  dataSettlement: PagedResponseModel<SalesRemissionSelectionTableModel> = new PagedResponseModel<SalesRemissionSelectionTableModel>();
  defaultStoreIdForBranch: number | null = null
  detailData: PagedResponseModel<InvoiceDetailRegisterModel> = new PagedResponseModel<InvoiceDetailRegisterModel>();
  disabledForm: boolean = false;
  disableSettlementButton: boolean = false;
  electronicInvoiceInterfaceCode: string = "";
  enableSetInvoiceWalletType: boolean = false;
  enterpriseId: number = 0;
  expirationDays: number | null = 0;
  expirationDaysCompany: number | null = 0;
  exporterInvoiceDetailsPreview: boolean = false;
  finishLoadingPrint: boolean = false;
  filtersSettlement: ColumnResponseModel[] = [];
  formInvoiceFirst: FormGroup = new FormGroup({});
  formInvoiceFooter: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  hasSalesRemissions: boolean = false;
  headerSettlement: ColumnResponseModel[] = [];
  iconPreviewInvoice: string = "pi pi-eye";
  iconStateInvoice: string = "";
  inputsForModals$ = new BehaviorSubject<any>({
    invoiceId: 0,
    invoiceStateId: 0,
    permissionUpdatable: false
  });
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  inputsForInvoiceInformation$ = new BehaviorSubject<any>({
    invoiceModel: 0,
    permissionUpdatable: false,
    bussinessDocumentsTypeIsRental: "",
    enableSetInvoiceWalletType: false,
    disabledForm: false,
    listSellers: [],
    listZones: [],
    sellerId: 0,
  });
  inputsForCopyInvoice$ = new BehaviorSubject<any>({
    invoiceModel: 0,
    listBussinessDocumentsTypes: []
  });
  inputsForPrintRange$ = new BehaviorSubject<any>({
    invoiceModel: 0,
  });
  invoiceContract: InvoiceModel = new InvoiceModel();
  invoiceId: number;
  invoiceTraffic: string = '';
  invoicesPrintModel: InvoicesPrintsModel[] = [];
  invoiceStateString: string = '';
  invoicingCutoffCode: string = '';
  isOpened: string | undefined = undefined;
  isFormView: boolean = false;
  inputsForSettlementModals$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    companyId: 0,
    invoiceId: 0,
    settlementType: 0,
    filters: [],
  });
  inputsForGeneralDiscount$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    companyId: 0,
    invoiceModel: 0,
  });
  limit: number = 10;
  listBranches: any[] = [];
  listBussinessDocumentsTypes: any[] = [];
  listClients: CustomListDropdown[] = [];
  listCostCenters: any[] = [];
  filteredCostCenters: any[] = [];
  listEnterprises: CustomListDropdown[] = [];
  listFiles: any[] = [];
  listIvaTypes: CustomListDropdown[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  listPaymentMethods: any[] = [];
  listSellers: any[] = [];
  listSettlementTypes: CustomListDropdown[] = [
    { label: '<Ninguno>', value: 0 },
    { label: 'Vta.Nuevo', value: 1 },
    { label: 'Vta.Usado', value: 2 },
    { label: 'Fra.Anticipada', value: 3 },
  ];
  listTypeDIANs: any[] = [];
  listZones: any[] = [];
  limitSettlement: number = 10;
  messageStateInvoice: string = "";
  nameWindow: string = 'Captura Facturas';
  output$ = new Subject<any>();
  outputGeneralDiscount$ = new Subject<any>();
  outputForAttachFiles$ = new Subject<any>();
  page: number = 1;
  pageSettlement: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  permissionPrint: boolean = false;
  previewInvoice: boolean = false;
  printInvoiceFormat: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  sellerId: number = 0;
  showAllCostCenter: number = CostCenterEnums.Todos;
  stateClientId: number | null = 0;
  stateCostCenterId: number = ClientStateEnums.activo;
  subscription: Subscription;
  swSelfRetainerEnterprise: boolean = false;
  swSelfRetainer: boolean = false;
  swElectronicInvoice: boolean = false;
  titlePreviewInvoice: string = "Vista Previa";
  titleStateInvoice: string = "";
  totalAIU: number = 0;
  typeBussines: number = TypeConceptEnums.tipoNegocio;
  updateTotals: boolean = false;
  url: string = "invoice";
  userAuthenticated: UserModel = new UserModel();
  valueToPay: string = "";
  visibleLoading: boolean = true;
  swSalesRemission: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private bussinessDocumentsResolutionService: BussinessDocumentsResolutionService,
    private costCenterService: CostCenterService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private invoiceDetailService: InvoiceDetailService,
    private invoiceService: InvoiceService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private salesRemissionService: SalesRemissionService,
    private sellerService: SellerService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private headerService: HeaderService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.invoiceContract);
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} -  ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    this.activatedRoute.params.subscribe(params => {
      this.invoiceId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    await this.getPermissionPrint();
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeSettlement(payload);
          break;
        case 'onFilterChange':
          this.onFilterSettlement(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  addDaysToDate(days: number | null) {
    if (days != null && days != 0) {
      const date = new Date(this.formInvoiceFirst.get("dateInvoice")?.value);
      const dateExpiration: Date = moment(date).add(days, 'days').toDate();
      this.formInvoiceFirst.controls["dateExpiration"].patchValue(dateExpiration);
    }
  }

  applyExpirationForNewInvoice() {
    if (this.invoiceId === 0) {
      this.addDaysToDate(this.expirationDaysCompany);
      this.expirationDays = this.expirationDaysCompany;
    }
  }

  async blockInvoice(check: boolean) {
    if (this.invoiceContract.invoiceId != 0) {
      try {
        this.invoiceContract = await firstValueFrom(this.invoiceService.blockInvoice(this.invoiceContract.invoiceId));
        this.validateForm(this.invoiceContract);
      } catch (error) {
        setTimeout(() => this.formInvoiceFirst.controls["swBlock"].patchValue(!check));
        console.error('Error al bloquear la factura.', error);
      }
    } else {
      setTimeout(() => this.formInvoiceFirst.controls["swBlock"].patchValue(!check));
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la factura.', 'Atención');
    }
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      await this.getFirstEnterpriseByBranch();
      await this.getAllLists('enterprises', 'costCenters',
        'sellers', 'zones', 'bussinessDocumentsTypes');
      this.createNewInvoice();
    }
  }

  changeBussinessDocumentsType() {
    this.branchId = this.formInvoiceFirst.get("branchId")?.value;
    this.enterpriseId = this.formInvoiceFirst.get("enterpriseId")?.value;
    this.bussinessDocumentsTypeId = this.formInvoiceFirst.get("bussinessDocumentsTypeId")?.value;
    this.createNewInvoice();
  }

  async changeConsecutive() {
    let consecutive = this.formInvoiceFirst.get("consecutive")?.value;
    if (this.invoiceContract.consecutive == consecutive) return;
    const branchId = this.formInvoiceFirst.get("branchId")?.value;
    const enterpriseId = this.formInvoiceFirst.get("enterpriseId")?.value;
    const bussinessDocumentsTypeId = this.formInvoiceFirst.get("bussinessDocumentsTypeId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una Empresa.', 'Atención');
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un Tipo de Documento Comercial.', 'Atención');
      return;
    } else if (consecutive == 0) {
      consecutive = null;
    }

    if (consecutive == null) {
      this.invoiceId = 0;
      const modelInvoice = new InvoiceModel();
      modelInvoice.branchId = branchId;
      modelInvoice.enterpriseId = enterpriseId;
      modelInvoice.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
      this.invoiceContract = modelInvoice;
    } else {
      try {
        this.invoiceContract = await firstValueFrom(this.invoiceService.getInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive));
        this.invoiceId = this.invoiceContract.invoiceId;
        this.validateForm(this.invoiceContract);
        this.location.replaceState(`/invoice/register/${this.invoiceId}`);
      } catch (error) {
        const modelInvoice = new InvoiceModel();
        modelInvoice.invoiceId = -1;
        modelInvoice.branchId = branchId;
        modelInvoice.enterpriseId = enterpriseId;
        modelInvoice.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
        modelInvoice.consecutive = consecutive;
        console.error('Error al buscar la factura por llaves.', error);
      }
    }
  }

  async changeEnterprise(enterpriseId: number) {
    this.branchId = this.formInvoiceFirst.get("branchId")?.value;
    this.enterpriseId = enterpriseId;

    await Promise.all([
      this.getFirstBussinessDocumentsType(),
      this.getAllLists('bussinessDocumentsTypes')
    ]);
    this.createNewInvoice();
  }

  changeInvoice(invoiceModel: InvoiceModel) {
    this.invoiceContract = invoiceModel;
    this.validateForm(this.invoiceContract);
  }

  async changeStateInvoice() {
    if (this.invoiceContract.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La factura no está guardada.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de Facturas. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    try {
      this.invoiceContract = await firstValueFrom(this.invoiceService.setStateInvoice(this.invoiceContract.invoiceId));
      this.toastHandlerService.showToast(
        'success',
        'El estado de la factura se modificó exitosamente.'
      );
      this.validateForm(this.invoiceContract);
    } catch (error) {
      console.error('Error al cambiar el estado de la factura.', error);
    }
  }



  clicNewDetail(event?: any) {
    // 1. Detener cualquier propagación remanente
    if (event) {
      event.stopPropagation();
      event.preventDefault();
      //sw para abrir y cerrar formulario y accordion
      this.isFormView = !this.isFormView
      if (!this.isFormView) setTimeout(() => { this.isFormView = true }, 100);
    }

    if (this.invoiceContract.invoiceId != 0) {
      this.activePanel = "0";
      this.showAccordion = true;
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la factura.', 'Atención');
    }
  }

  clearForm() {
    this.invoiceContract = new InvoiceModel();
    this.previewInvoice = false;
    this.iconPreviewInvoice = "pi pi-eye";
    this.titlePreviewInvoice = "Vista Previa";
  }

  close() {
    if (this.previewInvoice) {
      this.previewInvoice = false;
      this.iconPreviewInvoice = "pi pi-eye";
      this.titlePreviewInvoice = "Vista Previa";
    } else {
      this.router.navigate(['/invoice']);
    }
  }

  async createNewInvoice() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear facturas.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.clientId = 0;
    this.invoiceId = 0;
    this.quantityDetails = 0;
    this.codeCurrency = "";
    this.invoicingCutoffCode = "";
    this.electronicInvoiceInterfaceCode = "";
    this.stateClientId = ClientStateEnums.activo;
    this.stateCostCenterId = ClientStateEnums.activo;
    this.invoicesPrintModel = [];
    this.filteredCostCenters = this.listCostCenters;
    this.invoiceContract = new InvoiceModel();
    this.invoiceContract.branchId = this.branchId;
    this.invoiceContract.enterpriseId = this.enterpriseId;
    this.invoiceContract.enterpriseSwSelfRetainer = this.swSelfRetainerEnterprise;
    this.invoiceContract.bussinessDocumentsTypeId = this.bussinessDocumentsTypeId;
    this.invoiceContract.settlementType = SettlementTypeEnums.none;
    await this.validateForm(this.invoiceContract);
    this.applyExpirationForNewInvoice();
    this.location.replaceState(`/invoice/register`);
    this.branchId = this.invoiceContract.branchId;
    this.enterpriseId = this.invoiceContract.enterpriseId;
    this.bussinessDocumentsTypeId = this.invoiceContract.bussinessDocumentsTypeId;
  }

  createDetail(event: Event) {
    event.stopPropagation();
    // lógica para crear detalle
  }

  async deleteInvoice() {
    if (this.invoiceContract.invoiceId != 0) {
      if (this.permissionUpdatable) {
        const result = await Swal.fire({
          title: 'Atención',
          text: `¿Realmente desea eliminar la factura ${this.invoiceContract.consecutive}?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        });
        if (result.isConfirmed) {
          try {
            await firstValueFrom(this.invoiceService.deleteInvoice(this.invoiceContract.invoiceId));
            this.toastHandlerService.showToast('success', 'La Factura fue eliminada exitosamente.');
            this.createNewInvoice();
          } catch (error) {
            console.error('Error al eliminar la factura.', error);
          }
        }
      } else {
        this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para eliminar Facturas. Comuníquese con el administrador del sistema.', 'Atención');
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la factura.', 'Atención');
    }
  }

  deleteFile(file: any) {
    if (this.invoiceContract.invoiceId != 0) {
      Swal.fire({
        title: 'Atención',
        text: "¿Realmente desea eliminar el adjunto seleccionado?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await firstValueFrom(this.invoiceService.deleteFilesToInvoice(this.invoiceContract.invoiceId, file));
            this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
            this.getFilesToInvoice();
          } catch (error) {
            console.error('Error catch:', error);
          }
        }
      });
    }
  }

  downloadFile(fileName: any) {
    if (this.invoiceContract.invoiceId != 0) {
      this.invoiceService.downloadFileToInvoice(this.invoiceContract.invoiceId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  async editInvoice() {
    this.invoicesPrintModel = [];
    await this.getInvoiceById();
  }

  exporterDetailsPreview() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.ExportarVistaPrevia)) {
      this.exporterInvoiceDetailsPreview = !this.exporterInvoiceDetailsPreview;
    } else {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para exportar la Vista Previa de la Factura, comuniquese con el administrador del sistema.', 'Atención');
    }
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'enterprises' | 'clients' | 'costCenters' | 'typeDIANs' | 'ivaTypes' | 'bussinessDocumentsTypes'
    | 'paymentMethods' | 'sellers' | 'zones'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        enterprises: async () => {
          this.listEnterprises = await firstValueFrom(
            this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)
          );
        },
        clients: async () => {
          this.listClients = await firstValueFrom(
            this.invoiceService.getAllClientsForSelectAsync()
          );
        },
        costCenters: async () => {
          this.listCostCenters = await firstValueFrom(
            this.invoiceService.getAllCostCenterByBranchIdForSelect(this.branchId)
          );
          this.filteredCostCenters = this.listCostCenters;
        },
        typeDIANs: async () => {
          this.listTypeDIANs = await firstValueFrom(
            this.invoiceService.getAllTypeDIANForSelectAsync()
          );
        },
        sellers: async () => {
          this.listSellers = await firstValueFrom(
            this.sellerService.getAllSellersForSelectByBranchIdAsync(this.branchId)
          );
        },
        paymentMethods: async () => {
          this.listPaymentMethods = await firstValueFrom(
            this.invoiceService.getAllPaymentMethodsForSelectAsync()
          );
        },
        ivaTypes: async () => {
          this.listIvaTypes = await firstValueFrom(
            this.invoiceService.getAllIvaTypeForSelectAsync()
          );
        },
        zones: async () => {
          this.listZones = await firstValueFrom(
            this.invoiceService.getAllZonesByBranchIdForSelects(this.branchId)
          );
        },
        bussinessDocumentsTypes: async () => {
          this.listBussinessDocumentsTypes = await firstValueFrom(
            this.invoiceService.getAllBussinessDocumentsTypesForSelectAsync(this.branchId, this.enterpriseId));
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.zones(),
          lists.sellers(),
          lists.clients(),
          lists.ivaTypes(),
          lists.branches(),
          lists.typeDIANs(),
          lists.enterprises(),
          lists.costCenters(),
          lists.bussinessDocumentsTypes(),
          lists.paymentMethods()
        ]);
      }
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getDetailsInvoiceWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.invoiceDetailService.getInvoicesDetailsByInvoiceIdWithPagination(this.page,
        this.limit, this.columnSort, this.ascendant, this.invoiceId));
      this.quantityDetails = this.detailData.totalItems;
    } catch (error) {
      console.error('Error al buscar los detalles de las facturas.', error);
    }
  }

  async getElectronicInvoiceInterfaceCode(electronicInvoiceInterfaceId: number | null) {
    if (electronicInvoiceInterfaceId != null && electronicInvoiceInterfaceId != 0) {
      this.electronicInvoiceInterfaceCode = (await firstValueFrom(this.invoiceService.getElectronicInvoiceInterfaceCodeById(electronicInvoiceInterfaceId))).toString();
    } else {
      this.electronicInvoiceInterfaceCode = "";
    }
  }

  async getFormatByCompanyAndCode() {
    try {
      this.formatModel = await firstValueFrom(
        this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.invoice)
      );
    } catch (error) {
      console.error('Error al obtener el formato:', error);
    }
  }

  getDefaultStoreForBranch(branchId: number) {
    const branch = this.listBranches.find(x => x.value === branchId);
    if (branch) {
      this.defaultStoreIdForBranch = branch.swBranchStore ? branch.storeId : 0;
    }
  }

  async getBranch(branchId: number, reload: boolean) {
    try {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      this.branchId = branch.branchId;

      if (reload) {
        await this.changeBranch(branch.branchId, false);
      }
    } catch (error) {
      console.error('Error al obtener la sucursal.', error);
    }
  }

  async getBussinessDocumentsType(bussinessDocumentsTypeId: number | null, reload: boolean) {
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      const bussinessDocumentsType = this.listBussinessDocumentsTypes.find(x => x.value == bussinessDocumentsTypeId);
      if (bussinessDocumentsType) {
        this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
        const isRental = bussinessDocumentsType.isRental === true;
        isRental ? this.bussinessDocumentsTypeIsRental = 'Alquiler' : this.bussinessDocumentsTypeIsRental = 'Venta';
        if (bussinessDocumentsType.bussinessDocumentsDianTypeId == ElectronicDocumentEnums.tipoDianFacturaExportacion) {
          this.showAllCostCenter = CostCenterEnums.CcoMonedaDiferente;
        } else {
          this.showAllCostCenter = CostCenterEnums.Todos;
        }
      } else {
        this.showAllCostCenter = CostCenterEnums.Todos;
        return;
      }
    } else {
      this.showAllCostCenter = CostCenterEnums.Todos;
    }
    if (reload) {
      this.changeBussinessDocumentsType();
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formInvoiceFirst.get("branchId")?.value;
    const enterpriseId = this.formInvoiceFirst.get("enterpriseId")?.value;
    const bussinessDocumentsTypeId = this.formInvoiceFirst.get("bussinessDocumentsTypeId")?.value;
    let consecutive = this.formInvoiceFirst.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una empresa.', 'Atención');
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de documento comercial.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleInvoiceNavigation(buttonClick, branchId, enterpriseId, bussinessDocumentsTypeId, consecutive);
  }

  async handleInvoiceNavigation(buttonClick: any, branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number, consecutive: number) {
    const actionMap: Record<string, () => Promise<InvoiceModel>> = {
      first: () => firstValueFrom(this.invoiceService.getFirstInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId)),
      previus: () => firstValueFrom(this.invoiceService.getPreviusInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive)),
      next: () => firstValueFrom(this.invoiceService.getNextInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive)),
      last: () => firstValueFrom(this.invoiceService.getLastInvoiceByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.invoiceId = 0;
      this.invoiceContract = new InvoiceModel();
      return;
    }
    try {
      const invoice = await action();
      this.invoiceId = invoice.invoiceId;
      this.invoiceContract = invoice;
      await this.validateForm(this.invoiceContract);
      if (this.previewInvoice) await this.getPrintInvoices();
      this.location.replaceState(`/invoice/register/${this.invoiceId}`);
    } catch (error) {
      this.invoiceContract = new InvoiceModel();
      this.invoiceContract.invoiceId = 0;
      console.error(`Error al buscar la factura (${buttonClick.target.id}).`, error);
    }
  }


  getClass(selection: string): string {
    const state = selection === 'client'
      ? this.stateClientId
      : this.stateCostCenterId;

    return state === ClientStateEnums.activo ? '' : 'state-inactive';
  }

  async getColumnsForSalesRemissionSelection() {
    try {
      if (this.headerSettlement.length != 0) { return; }
      this.headerSettlement = await firstValueFrom(this.salesRemissionService.getColumnsForSalesRemissionSelection());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de facturas.', error);
    }
  }

  async getClient(clientId: number | null, validate: boolean) {
    this.filterCostCenterByClientId(clientId);
    const clientOld = this.invoiceContract.clientId;
    if (clientId != null && clientId != 0) {
      if (clientOld != clientId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast('error', 'No puede cambiar el cliente si la factura tiene detalle.', 'Atención');
      } else {
        const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
        if (client.clientStateId == ClientStateEnums.inactivo && validate) {
          this.toastHandlerService.showToast('warning', 'El cliente seleccionado se encuentra inactivo.', 'Atención');
          this.stateClientId = client.clientStateId as number | null;
          this.formInvoiceFirst.controls["clientId"].patchValue(0);
          this.formInvoiceFirst.controls["costCenterId"].patchValue(0);
          this.filteredCostCenters = this.listCostCenters;
          return;
        }
        if (client) {
          this.clientId = clientId;
          this.codeCurrency = client.codeCurrency;
          this.stateClientId = client.clientStateId as number | null;
          this.expirationDays = client.expirationDays;

          const exist = this.listClients.some(c => c.value === this.clientId);
          if (!exist) {
            this.listClients.push({ label: client.label, value: this.clientId });
          }
          this.formInvoiceFirst.controls["clientId"].patchValue(this.clientId);

          //Asignar fecha de vencimiento
          if (validate) {
            if (client.swExpirationDays) {
              this.addDaysToDate(this.expirationDays);
            } else {
              this.addDaysToDate(this.expirationDaysCompany);
            }
          }
          //Valido si la empresa NO tiene autorretención
          if (!this.swSelfRetainerEnterprise && this.invoiceId == 0) {
            this.swSelfRetainer = client.swSimpleTaxRegime;
            this.formInvoiceFirst.controls["enterpriseSwSelfRetainer"].patchValue(client.swSimpleTaxRegime);
          }
          //Si cambio el cliente, limpio el cco
          if (clientOld != 0 && clientOld != clientId) {
            this.getCostCenter(null, false);
          }
        } else {
          if (this.quantityDetails != 0) {
            this.toastHandlerService.showToast('error', 'Error al buscar el elemento, por favor refresque la página.', 'Error');
          } else {
            this.formInvoiceFirst.controls["clientId"].patchValue(0);
            this.codeCurrency = "";
            this.clientId = 0;
            this.stateClientId = ClientStateEnums.activo;
            this.getCostCenter(null, false);
            //Restablecer fecha de vencimiento
            if (validate) {
              this.addDaysToDate(this.expirationDaysCompany);
            }
            this.formInvoiceFirst.controls["costCenterId"].patchValue(0);
          }
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast('error', 'No puede limpiar el cliente si la factura tiene detalle.', 'Error');
      } else {
        this.clientId = 0;
        this.codeCurrency = "";
        this.formInvoiceFirst.controls["clientId"].patchValue(0);
        this.getCostCenter(null, false);
        //Restablecer fecha de vencimiento
        this.addDaysToDate(this.expirationDaysCompany);
        this.formInvoiceFirst.controls["costCenterId"].patchValue(0);
      }
    }
  }

  filterCostCenterByClientId(clientId: number | null) {
    const rowsFiltered = this.listCostCenters.filter(cc => cc.clientId === clientId);
    if (clientId != null) {
      this.filteredCostCenters = rowsFiltered;
      const costCenterId = this.formInvoiceFirst.get("costCenterId")?.value;
      const costCenterClient = this.listCostCenters.find(x => x.clientId == clientId);
      if ((costCenterId && costCenterClient) && costCenterClient.value != costCenterId) {
        this.formInvoiceFirst.controls["costCenterId"].patchValue(0);
      }
    } else {
      this.filteredCostCenters = this.listCostCenters;
    }
  }

  async getCostCenter(costCenterId: number | null, validate: boolean) {
    if (costCenterId != null && costCenterId != 0) {
      const costCenterOld = this.invoiceContract.costCenterId;
      const costCenterModel = await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
      if (costCenterOld != costCenterModel.costCenterId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast('error', 'No puede cambiar el c.costos si la factura tiene detalle.', 'Error');
      } else {
        const exist = this.listCostCenters.some(c => c.value == costCenterId);
        if (!exist && costCenterModel) {
          this.listCostCenters.push({ clientId: costCenterModel.clientId, label: `${costCenterModel.code} - ${costCenterModel.name}`, value: costCenterId });
        }
        this.stateCostCenterId = costCenterModel.constructionSite.constructionSiteStateId;
        this.formInvoiceFirst.controls["clientId"].patchValue(costCenterModel.clientId);
        this.formInvoiceFooter.controls["ivaTypeId"].patchValue(costCenterModel.ivaTypeId);
        this.formInvoiceFooter.controls["administrationRate"].patchValue(costCenterModel.administrationRate);
        this.formInvoiceFooter.controls["incidentalRate"].patchValue(costCenterModel.incidentalRate);
        this.formInvoiceFooter.controls["utilityRate"].patchValue(costCenterModel.utilityRate);
        this.totalAIU = (costCenterModel.administrationRate + costCenterModel.incidentalRate + costCenterModel.utilityRate);
        await this.getClient(costCenterModel.clientId, validate);
        this.formInvoiceFirst.controls["costCenterId"].patchValue(costCenterId);
        if (this.invoiceContract.costCenterId === costCenterId) {
          this.sellerId = this.invoiceContract.sellerId;
        } else {
          const sellerModel = await firstValueFrom(this.sellerService.getSellerByCostCenterId(costCenterId));
          this.sellerId = sellerModel ? sellerModel.sellerId : 0;
        }
        if (validate) {
          if (costCenterModel.constructionSite.constructionSiteStateId == ConstructionSiteStateEnums.inactiva) {
            this.toastHandlerService.showToast('warning', 'El centro de costos seleccionado se encuentra inactivo.', 'Atención');
            this.formInvoiceFirst.controls["costCenterId"].patchValue(0);
            this.formInvoiceFirst.controls["clientId"].patchValue(0);
            this.filteredCostCenters = this.listCostCenters.filter(x => x.value != costCenterId);
            return;
          }
        }
      }
    } else {
      if (this.invoiceContract.costCenterId != null && this.invoiceContract.costCenterId != 0 && this.quantityDetails != 0) {
        this.toastHandlerService.showToast('error', 'No puede limpiar el c.costos si la factura tiene detalle.', 'Error');
      } else {
        this.formInvoiceFirst.controls["costCenterId"].patchValue(0);
        this.formInvoiceFooter.controls["ivaTypeId"].patchValue(IvaTypeEnums.pleno);
        this.formInvoiceFooter.controls["administrationRate"].patchValue(0);
        this.formInvoiceFooter.controls["incidentalRate"].patchValue(0);
        this.formInvoiceFooter.controls["utilityRate"].patchValue(0);
        this.sellerId = this.listSellers[0].value;
        this.totalAIU = (0);
      }
      this.stateCostCenterId = ClientStateEnums.activo;
    }
  }

  async getEnterprise(enterpriseId: number, reload: boolean) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
      this.enterpriseId = response.enterpriseId;
      this.swElectronicInvoice = response.swElectronicInvoice;
      this.swSelfRetainerEnterprise = response.swSelfRetainer;
      if (reload) {
        await this.changeEnterprise(response.enterpriseId);
      }
    } catch (error) {
      console.error('Error al obtener la empresa.', error);
    }
  }

  async getFilesToInvoice() {
    try {
      this.listFiles = await firstValueFrom(this.invoiceService.getFilesToInvoice(this.invoiceId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.companyId = response.companyId;
      this.branchId = response.branchId;
      await this.getFirstEnterpriseByBranch();
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getInitialData() {
    try {
      await this.getFirstBranchByUserAuthenticated();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar la sucursal del usuario autenticado.', error);
    }
  }

  async getFirstBussinessDocumentsType() {
    try {
      const bussinessDocumentsClass = BussinessDocumentsClassEnums.factura;
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(bussinessDocumentsClass, this.enterpriseId));
      this.getBussinessDocumentsType(response.bussinessDocumentsTypeId, false);
      this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
    } catch (error) {
      console.error('Error al buscar el tipo de documento de la factura.', error);
    }
  }

  async getFirstEnterpriseByBranch() {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(this.branchId));
      if (!response) {
        this.enterpriseId = 0;
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
      } else {
        this.enterpriseId = response.enterpriseId;
        await Promise.all([
          this.getFirstBussinessDocumentsType(),
          this.getEnterprise(this.enterpriseId, false),
        ]);
      }
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getInvoiceById() {
    try {
      const response = await firstValueFrom(this.invoiceService.getInvoiceById(this.invoiceId));
      this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
      this.enterpriseId = response.enterpriseId;
      this.invoiceContract = response;
      await this.changeBranch(response.branchId, true);
      this.validateForm(this.invoiceContract);
    } catch (error) {
      console.error('Error al buscar la factura.', error);
    }
  }

  async getInvoicingCutoffCode(invoicingCutoffId: number | null) {
    if (invoicingCutoffId != null && invoicingCutoffId != 0) {
      this.invoicingCutoffCode = (await firstValueFrom(this.invoiceService.getInvoicingCutoffCodeByIdAsync(invoicingCutoffId))).toString();
    } else {
      this.invoicingCutoffCode = "";
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Error');
      }
    } else {
      localStorage.clear();
    }
    this.setInputsForModal();
    this.getGeneralParametersByCompany();
    await this.getUserAuthenticated();
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow(),
      this.getFormatByCompanyAndCode()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Invoice));
    } catch (error) {
      console.error('Error loading permissions for invoice window:', error);
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.invoiceService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión', error);
    }
  }


  async getPrintInvoicesByRange(invoicesPrintModel: InvoicesPrintsModel[]) {
    if (invoicesPrintModel.length) {
      this.printInvoiceFormat = true;
      this.previewInvoice = false;
      this.iconPreviewInvoice = "pi pi-eye";
      this.titlePreviewInvoice = "Vista Previa";
      setTimeout(() => this.printInvoice(invoicesPrintModel));
    }
  }

  async getParamsPrint(params: any) {
    this.invoiceTraffic = params.traffic;
    await this.getPrintInvoicesByRange(params.invoicesPrint)
  }

  async getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swSalesRemission = response.some(x => x.generalParameterId === GeneralParameterEnums.manejaRemisionesVenta);
    });
    this.listObservers.push(load);
  }

  async getSalesRemissionsByInvoiceId(invoiceId: number) {
    try {
      if (this.swSalesRemission) {
        this.hasSalesRemissions = await firstValueFrom(
          this.salesRemissionService.getSalesRemissionsByInvoiceId(invoiceId)
        );
      } else {
        this.hasSalesRemissions = false;
      }
    } catch (error) {
      this.hasSalesRemissions = false;
      console.error('Error al validar si la factura tiene remisiones de venta asociadas.', error);
    }
  }

  async getUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
      this.expirationDaysCompany = response.company ? response.company.invoiceExpirationDays : null;
      this.companyId = response.companyId;
      this.userAuthenticated = response;
    } catch (error) {
      console.error('Error obtaining authenticated user:', error);
    }
  }

  async getPrintInvoices() {
    try {
      this.visibleLoading = true;
      this.invoicesPrintModel = await firstValueFrom(this.invoiceService.printsInvoices(this.invoiceContract.invoiceId, null, null, false));
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  async getSalesRemissionsForSelection() {
    const { clientId, settlementType } = this.invoiceContract;
    try {
      this.dataSettlement = await firstValueFrom(this.salesRemissionService.getSalesRemissionsForSelection(settlementType, clientId,
        this.pageSettlement, this.limitSettlement, this.columnSortSettlement, this.ascendantSettlement, this.filtersSettlement));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los pedidos', error);
    }
  }

  async getSettlementData() {
    try {
      await this.getColumnsForSalesRemissionSelection();
      await this.getSalesRemissionsForSelection();
    } catch (error) {
      console.error('Error al cargar los datos de liquidación.', error);
    }
  }

  getSettlement(settlementType: number) {
    const previousSettlementType = this.invoiceContract.settlementType;
    if ((previousSettlementType !== settlementType) && (this.quantityDetails > 0)) {
      setTimeout(() => this.formInvoiceFirst.controls["settlementType"].patchValue(previousSettlementType));
      this.toastHandlerService.showToast('error', 'No puede cambiar el tipo liquidación si la factura tiene detalle.');
      return;
    }
  }

  getUpdateInvoice(invoice: InvoiceModel) {
    this.invoiceContract = invoice;
    this.validateForm(this.invoiceContract);
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/invoice']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async handleInitialState() {
    if (this.invoiceId) {
      await this.editInvoice();
    } else {
      await this.getInitialData();
      this.createNewInvoice();
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getDetailsInvoiceWithPagination();
  }

  async onFilterSettlement(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersSettlement = this.removeDuplicates(filters);
    this.filtersSettlement.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeSettlement(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageSettlement = event.page;
    this.limitSettlement = event.pageSize;
    this.columnSortSettlement = event.sortField || null;
    this.ascendantSettlement = event.sortOrder === 1;
    await this.getSalesRemissionsForSelection()
  }

  async openAttachFile() {
    if (this.invoiceContract.invoiceId != 0 && this.invoiceContract.invoiceId != null) {
      await this.getFilesToInvoice();
      this.attachFileInvoiceComponent && this.attachFileInvoiceComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear una factura.', 'Atención');
    }
  }

  async openPreviewInvoice() {
    if (this.invoiceContract.invoiceId != 0) {
      this.previewInvoice = !this.previewInvoice;
      if (this.previewInvoice) {
        this.iconPreviewInvoice = "pi pi-address-book";
        this.titlePreviewInvoice = "Volver a factura";
        await this.getPrintInvoices();
      } else {
        this.iconPreviewInvoice = "pi pi-eye";
        this.titlePreviewInvoice = "Vista Previa";
      }
    } else {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado de la factura.`, 'Atención');
    }
  }

  async openSettlementModal() {
    const previousSettlementType = this.formInvoiceFirst.get('settlementType')?.value;
    const { clientId, settlementType } = this.invoiceContract;
    if (!clientId || clientId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe seleccionar un cliente antes de continuar.');
      return;
    }
    if (settlementType === SettlementTypeEnums.none) {
      this.toastHandlerService.showToast('warning', 'Seleccione un tipo de liquidación válido.');
      return;
    }
    if (previousSettlementType !== settlementType) {
      this.toastHandlerService.showToast('warning', 'Hay cambios sin guardar. Guarde los cambios antes de continuar.');
      return;
    }
    this.filtersSettlement = [];
    this.updateInputs();
    await this.getSettlementData();
    this.settlementSelectionModalComponent?.show();
  }

  async printInvoice(invoices: InvoicesPrintsModel[]) {
    this.toastHandlerService.clearAllToasts();
    this.invoicesPrintModel = invoices;
    //Inicializo variable
    this.finishLoadingPrint = false;
    //Imprimo las facturas
    await this.waitForComponenteImpresionToLoad();
    this.invoiceContract = await firstValueFrom(this.invoiceService.getInvoiceById(this.invoiceContract.invoiceId));
    this.validateForm(this.invoiceContract);
    //ocultar formato
    this.printInvoiceFormat = false;
  }

  async openGeneralConcept() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para aplicar descuentos,
        comuniquese con el administrador del sistema.`);
      return;
    }
    this.inputsForGeneralDiscount$.next({
      invoiceModel: this.invoiceContract,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledForm
    });
    this.generalDiscountComponent?.show();
  }

  async openInvoiceInformation() {
    this.inputsForInvoiceInformation$.next({
      invoiceModel: this.invoiceContract,
      permissionUpdatable: this.permissionUpdatable,
      bussinessDocumentsTypeIsRental: this.bussinessDocumentsTypeIsRental,
      enableSetInvoiceWalletType: this.enableSetInvoiceWalletType,
      disabledForm: this.disabledForm,
      listSellers: this.listSellers,
      listZones: this.listZones,
      sellerId: this.sellerId,
    });
    this.invoiceInformationComponent?.show();
  }


  async openCopyInvoice() {
    if (this.invoiceContract.invoiceId == 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado de la factura.`, 'Atención.');
      return;
    } else if (this.invoiceContract.swBlock) {
      this.toastHandlerService.showToast('warning', `El Documento Actualmente se encuentra Bloqueado, Consulte con el Administrador del Sistema.`, 'Atención.');
      return;
    } else if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', `No es posible copiar datos a esta factura. Ya tiene líneas de detalle.`, 'Atención.');
      return;
    }

    this.inputsForCopyInvoice$.next({
      invoiceModel: this.invoiceContract,
      listBussinessDocumentsTypes: this.listBussinessDocumentsTypes,
    });
    this.copyInvoiceComponent?.show();
  }

  async openPrintRange() {
    if (this.invoiceContract.enterprise.swElectronicInvoice && (this.invoiceContract.cufe == null || this.invoiceContract.cufe == '')) {
      this.toastHandlerService.showToast('warning', 'Una factura electrónica sin CUFE no puede ser impresa.');
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para imprimir Facturas. Comuníquese con el administrador del sistema.');
      return;
    }

    if (this.invoiceContract.invoiceId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la factura.');
      return;
    }

    this.inputsForPrintRange$.next({
      invoiceModel: this.invoiceContract
    });
    this.printRangeComponent?.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersSettlement = this.filtersSettlement.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersSettlement.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async refreshInvoiceData(event: any) {
    await Promise.all([
      this.getUpdateInvoice(event.invoice),
      this.getDetailsInvoiceWithPagination()
    ]);
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.invoiceId != 0 && this.invoiceId != null) {
      this.router.navigate(['/invoice/register/', this.invoiceId]);
    } else {
      this.router.navigate(['/invoice/register']);
    }
  }

  async reloadInvoice(params: any) {
    if (params.updateInvoice) {
      await this.getInvoiceById();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send(): Promise<any> {
    if (this.formInvoiceFirst.valid) {
      if (this.invoiceContract.invoiceId == 0) {
        //Si no definen un cco. asigno por defecto Iva pleno
        if (this.formInvoiceFirst.controls["costCenterId"].value == null || this.formInvoiceFirst.controls["costCenterId"].value == 0) {
          this.formInvoiceFooter.controls["ivaTypeId"].patchValue(IvaTypeEnums.pleno);
        }
      }
      const modelInvoice = this.setForm();
      if (modelInvoice.dateExpiration < modelInvoice.dateInvoice) {
        this.toastHandlerService.showToast('warning', `La fecha de vencimiento debe ser MAYOR o IGUAL a la fecha de la factura.`, 'Atención');
        this.formInvoiceFirst.controls["dateExpiration"].patchValue(0);
        return;
      }
      if (this.swElectronicInvoice && !await this.validateResolutionExpiration(modelInvoice.dateInvoice)) {
        return;
      }
      //Hago null, los campos que permiten ser nulos:
      if (modelInvoice.costCenterId == 0) modelInvoice.costCenterId = null;
      if (modelInvoice.invoiceOriginId == 0) modelInvoice.invoiceOriginId = null;
      if (modelInvoice.observation == "") modelInvoice.observation = null;
      if (modelInvoice.purchaseOrder == "") modelInvoice.purchaseOrder = null;
      if (modelInvoice.approvalNumber == "") modelInvoice.approvalNumber = null;
      if (modelInvoice.remission == "") modelInvoice.remission = null;
      if (modelInvoice.cufe == "") modelInvoice.cufe = null;
      if (modelInvoice.xmlName == "") modelInvoice.xmlName = null;
      modelInvoice.enterprise = null;
      const conceptTypeDIANId = this.setTypeDIAN(modelInvoice.ivaTypeId);
      if (this.invoiceId == 0) {
        // Agrego el Tipo DIAN por defecto
        modelInvoice.conceptTypeDIANId = conceptTypeDIANId;
        // Agrego el medio de pago por defecto
        modelInvoice.conceptPaymentMethodId = this.listPaymentMethods.find(x => x.code == InvoiceEnums.acuerdoMutuo)?.value;
        // Agrego la zona y el vendedor por defecto
        if (this.listZones && this.listZones.length > 0) {
          modelInvoice.zoneId = this.listZones[0].value;
        }
        if (this.sellerId && this.sellerId != 0) {
          modelInvoice.sellerId = this.sellerId;
        } else {
          this.sellerId = this.listSellers[0].value;
          modelInvoice.sellerId = this.sellerId;
        }
        try {
          const response = await firstValueFrom(this.invoiceService.createInvoice(modelInvoice));
          this.toastHandlerService.showToast('success', `La factura fue creada exitosamente.`, 'Atención');
          this.invoiceContract = response;
          this.invoiceId = this.invoiceContract.invoiceId;
          this.validateForm(this.invoiceContract);
          this.location.replaceState(`/invoice/register/${this.invoiceId}`);
          // Abrir automáticamente el acordeón de detalle al crear el encabezado
          this.activePanel = "0";
          this.showAccordion = true;
          this.isFormView = true;
        } catch (error) {
          console.error('Error al crear la factura.', error);
        }
      } else {
        try {
          this.invoiceContract.conceptTypeDIANId = conceptTypeDIANId;
          const response = await firstValueFrom(this.invoiceService.updateInvoice(this.invoiceContract));
          this.toastHandlerService.showToast('success', `La factura fue modificada exitosamente.`, 'Atención');
          this.invoiceContract = response;
          this.validateForm(this.invoiceContract);
        } catch (error) {
          console.error('Error al actualizar la factura.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  async setClient(clientId: number | null) {
    this.filterCostCenterByClientId(clientId);
    if (clientId != null && clientId != 0) {
      const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
      this.clientId = clientId;
      this.codeCurrency = client.codeCurrency;
      this.stateClientId = client.clientStateId as number | null;
      this.expirationDays = client.expirationDays;

      const exist = this.listClients.some(c => c.value === this.clientId);
      if (!exist) {
        this.listClients.push({ label: client.label, value: this.clientId });
      }
      this.formInvoiceFirst.controls["clientId"].patchValue(this.clientId);
    }
  }

  async setCostCenter(costCenterId: number | null) {
    if (costCenterId != null && costCenterId != 0) {
      const costCenterModel = await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
      this.stateCostCenterId = costCenterModel.constructionSite.constructionSiteStateId;

      const exist = this.listCostCenters.some(c => c.value == costCenterId);
      if (!exist && costCenterModel) {
        this.listCostCenters.push({ clientId: costCenterModel.clientId, label: `${costCenterModel.code} - ${costCenterModel.name}`, value: costCenterId });
      }
      this.formInvoiceFirst.controls["costCenterId"].patchValue(costCenterId);
    }
  }

  setForm(): any {
    this.formInvoiceFirst.controls["enterpriseSwSelfRetainer"].enable();
    this.formInvoiceFirst.controls["enterpriseSwIcaSelfRetainer"].enable();
    this.invoiceContract.branchId = this.formInvoiceFirst.get("branchId")?.value;
    this.invoiceContract.settlementType = this.formInvoiceFirst.get("settlementType")?.value;
    this.invoiceContract.enterpriseId = this.formInvoiceFirst.get("enterpriseId")?.value;
    this.invoiceContract.enterpriseSwSelfRetainer = this.formInvoiceFirst.get("enterpriseSwSelfRetainer")?.value;
    this.invoiceContract.bussinessDocumentsTypeId = this.formInvoiceFirst.get("bussinessDocumentsTypeId")?.value;
    this.invoiceContract.consecutive = this.formInvoiceFirst.get("consecutive")?.value;
    this.invoiceContract.dateInvoice = this.formInvoiceFirst.get("dateInvoice")?.value;
    this.invoiceContract.dateExpiration = this.formInvoiceFirst.get("dateExpiration")?.value;
    this.invoiceContract.clientId = this.formInvoiceFirst.get("clientId")?.value;
    this.invoiceContract.costCenterId = this.formInvoiceFirst.get("costCenterId")?.value;
    this.invoiceContract.ivaTypeId = this.formInvoiceFooter.get("ivaTypeId")?.value;
    this.invoiceContract.administrationRate = this.formInvoiceFooter.get("administrationRate")?.value;
    this.invoiceContract.incidentalRate = this.formInvoiceFooter.get("incidentalRate")?.value;
    this.invoiceContract.utilityRate = this.formInvoiceFooter.get("utilityRate")?.value;
    this.invoiceContract.observation = this.formInvoiceFirst.get("observation")?.value;
    this.invoiceContract.swBlock = this.formInvoiceFirst.get("swBlock")?.value;
    this.invoiceContract.purchaseOrder = this.formInvoiceFirst.get("purchaseOrder")?.value;
    this.invoiceContract.approvalNumber = this.formInvoiceFirst.get("approvalNumber")?.value;
    this.invoiceContract.remission = this.formInvoiceFirst.get("remission")?.value;
    setTimeout(() => this.formInvoiceFirst.controls["enterpriseSwSelfRetainer"].disable());
    setTimeout(() => this.formInvoiceFirst.controls["enterpriseSwIcaSelfRetainer"].disable());
    return this.invoiceContract;
  }

  setInputsForModal() {
    this.inputsForModals$.next({
      invoiceId: this.invoiceContract.invoiceId,
      invoiceStateId: this.invoiceContract.invoiceStateId,
      permissionUpdatable: this.permissionUpdatable
    });
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      enterpriseId: 'El campo empresa es obligatorio.',
      bussinessDocumentsTypeId: 'El campo tipo de documento es obligatorio.',
      dateInvoice: 'El campo fecha de factura es obligatorio.',
      dateExpiration: 'El campo fecha de vencimiento es obligatorio.',
      clientId: 'El campo cliente es obligatorio.',
      observation: 'El campo observación permite máximo 250 caracteres.',
      purchaseOrder: 'El campo orden de compra permite máximo 20 caracteres.',
      approvalNumber: 'El campo número de aprobación permite máximo 20 caracteres.',
      remission: 'El campo remisión permite máximo 20 caracteres.'
    };

    Object.keys(controlMessages).forEach(control => {
      const formControl = this.formInvoiceFirst.get(control);
      if (formControl && formControl.invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención');
      }
    });
  }

  setTypeDIAN(typeIva: number) {
    let codeTypeDian: number = 0;
    typeIva == IvaTypeEnums.sobreUtilidad ? codeTypeDian = TypeDianEnums.aiu : codeTypeDian = TypeDianEnums.estandar;
    //Busco datos del tipo Dian
    return this.listTypeDIANs.find(x => x.code == codeTypeDian)?.value;
  }

  toggleAccordion() {
    this.showAccordion = !this.showAccordion;
    this.isFormView = false;
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.invoiceService.attachFilesToInvoice(this.invoiceId, formData));
      await this.getFilesToInvoice();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  updateInputs() {
    this.inputsForSettlementModals$.next({
      headers: this.headerSettlement,
      data: this.dataSettlement,
      companyId: this.companyId,
      invoiceId: this.invoiceContract.invoiceId,
      settlementType: this.invoiceContract.settlementType,
      filters: this.filtersSettlement,
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [InvoiceEnums.abierta]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.invoiceId !== 0,
      },
      [InvoiceEnums.cerrada]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      },
      [InvoiceEnums.impresa]: {
        severity: 'info',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Impresa',
        isDisabled: true,
        enableConsecutive: true,
      },
      [InvoiceEnums.pagada]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Pagada',
        isDisabled: true,
        enableConsecutive: true,
      },
      [InvoiceEnums.anulada]: {
        severity: 'warn',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulada',
        isDisabled: true,
        enableConsecutive: true,
      }
    };

    const currentState = this.invoiceContract.invoiceStateId;
    const config = stateConfig[currentState];

    if (config) {
      this.severityState = config.severity;
      this.iconStateInvoice = config.icon;
      this.titleStateInvoice = config.title;
      this.invoiceStateString = config.text;
      this.disabledForm = config.isDisabled;
    }

    if (this.invoiceContract.invoiceStateId == InvoiceEnums.abierta && !this.invoiceContract.swBlock) {
      this.disabledForm = false;
      setTimeout(() => this.formInvoiceFirst.enable());
      if (this.invoiceId != 0) {
        setTimeout(() => this.formInvoiceFirst.controls["consecutive"].enable());
        this.disableSettlementButton = this.invoiceContract.settlementType == SettlementTypeEnums.none;
      } else {
        setTimeout(() => this.formInvoiceFirst.controls["consecutive"].disable());
        this.disableSettlementButton = true;
      }
    } else {
      this.disabledForm = true;
      this.disableSettlementButton = true;
      setTimeout(() => this.formInvoiceFirst.disable());
      setTimeout(() => this.formInvoiceFirst.controls["consecutive"].enable());
    }
    //Activo o desactivo el botón para cambiar el tipo de cartera:
    if (this.invoiceContract.invoiceId != 0 && !this.invoiceContract.swBlock) {
      const rentalPeriod = await firstValueFrom(this.invoiceService.getRentalPeriodByIdForRegisterInvoiceAsync(this.invoiceContract.rentalPeriodId));
      if ((rentalPeriod?.active && this.invoiceContract.invoiceStateId == InvoiceEnums.cerrada) ||
        this.invoiceContract.invoiceStateId == InvoiceEnums.impresa ||
        (!rentalPeriod?.active && this.invoiceContract.invoiceStateId != InvoiceEnums.anulada && this.invoiceContract.invoiceStateId != InvoiceEnums.pagada) ||
        !this.invoiceContract.swManual) {
        this.enableSetInvoiceWalletType = true;
      } else {
        this.enableSetInvoiceWalletType = false;
      }
    } else {
      this.enableSetInvoiceWalletType = false;
    }
    setTimeout(() => this.formInvoiceFooter.disable());
    //Valido si el usuario tiene permisos de actualizacion
    if (!this.permissionUpdatable) setTimeout(() => this.formInvoiceFirst.disable());
    setTimeout(() => this.formInvoiceFirst.controls["enterpriseSwSelfRetainer"].disable());
    if (this.invoiceContract.settlementType != SettlementTypeEnums.none) setTimeout(() => this.formInvoiceFirst.controls["remission"].disable());
    setTimeout(() => this.formInvoiceFirst.controls["enterpriseSwIcaSelfRetainer"].disable());
    setTimeout(() => this.formInvoiceFirst.controls["branchId"].enable());
    setTimeout(() => this.formInvoiceFirst.controls["enterpriseId"].enable());
    setTimeout(() => this.formInvoiceFirst.controls["bussinessDocumentsTypeId"].enable());
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.invoiceContract.consecutive,
      disabled: this.invoiceContract.invoiceStateId != InvoiceEnums.abierta
    });
  }

  validateDateExpiration() {
    const dateInvoice = new Date(this.formInvoiceFirst.get("dateInvoice")?.value);
    const dateExpiration = new Date(this.formInvoiceFirst.get("dateExpiration")?.value);
    if (dateExpiration < dateInvoice) {
      this.toastHandlerService.showToast('warning', `La fecha de vencimiento debe ser MAYOR o IGUAL a la fecha de la factura.`, 'Atención');
      this.formInvoiceFirst.controls["dateExpiration"].patchValue(0);
    }
  }

  async validatePeriodDate() {
    if (this.invoiceContract.invoiceId != 0 && this.invoiceContract.invoiceId != -1) {
      const periodInvoiceOldId = this.invoiceContract.rentalPeriodId;
      const dateInvoice = new Date(this.formInvoiceFirst.get("dateInvoice")?.value);
      const year = dateInvoice.getFullYear() as unknown;
      //Se suma 1 porque la función cuenta los meses desde la posición 0
      const month = dateInvoice.getMonth() + 1 as unknown;
      if (periodInvoiceOldId) {
        const rentalPeriod = await firstValueFrom(this.invoiceService.getRentalPeriodByIdForRegisterInvoiceAsync(periodInvoiceOldId));
        if (rentalPeriod) {
          if (!rentalPeriod.active) {
            this.toastHandlerService.showToast('warning', `La fecha ingresada pertenece a un período de alquiler cerrado.`, 'Atención');
            this.disabledForm = true;
            return;
          }
          if (this.quantityDetails != 0) {
            if (year != rentalPeriod.year || month != rentalPeriod.period) {
              this.toastHandlerService.showToast('warning', `No se puede cambiar la fecha a un período de alquiler diferente, mientras la factura tenga detalle.`, 'Atención');
              this.disabledForm = true;
              return;
            }
          }
        } else {
          //Si no encontró el periodo en la lista es por que no existe
          this.toastHandlerService.showToast('warning', `La fecha ingresada no existe en período de alquiler.`, 'Atención');
          this.disabledForm = true;
          return;
        }
      }
    }
    //Asignar fecha de vencimiento
    this.addDaysToDate(this.expirationDays);
    this.validateDateExpiration()
  }

  async validateResolutionExpiration(dateInvoice: Date): Promise<boolean> {
    try {
      const status = await firstValueFrom(this.bussinessDocumentsResolutionService.getResolutionExpirationStatus(dateInvoice,
        this.enterpriseId));
      const messages: Partial<Record<BussinessDocumentsResolutionStatusEnums, { type: 'warning' | 'error'; text: string }>> = {
        [BussinessDocumentsResolutionStatusEnums.aboutToExpire]: {
          type: 'warning',
          text: 'La resolución está por vencer (faltan 2 días o menos).',
        },
        [BussinessDocumentsResolutionStatusEnums.expired]: {
          type: 'error',
          text: 'La resolución ha vencido. No se puede continuar.',
        },
      };
      const message = messages[status as BussinessDocumentsResolutionStatusEnums];
      if (message) { this.toastHandlerService.showToast(message.type, message.text); }
      return status !== BussinessDocumentsResolutionStatusEnums.expired;
    } catch (error) {
      console.error('Error al validar la vigencia de la resolución.', error);
      return false;
    }
  }

  async validateForm(invoice: InvoiceModel) {
    return new Promise((resolve) => {
      this.formInvoiceFirst = this.formBuilder.group({
        branchId: [invoice.branchId, [Validators.required, Validators.min(1)]],
        enterpriseId: [invoice.enterpriseId, [Validators.required, Validators.min(1)]],
        settlementType: [invoice.settlementType, [Validators.required]],
        enterpriseSwSelfRetainer: [invoice.enterpriseSwSelfRetainer],
        bussinessDocumentsTypeId: [invoice.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)]],
        consecutive: [invoice.consecutive, [Validators.required]],
        dateInvoice: [invoice.dateInvoice ? this.dateConverterService.convertDatePreserveDay(invoice.dateInvoice) : null, [Validators.required]],
        dateExpiration: [invoice.dateExpiration ? this.dateConverterService.convertDatePreserveDay(invoice.dateExpiration) : null, [Validators.required]],
        clientId: [invoice.clientId, [Validators.required, Validators.min(1)]],
        costCenterId: [invoice.costCenterId],
        observation: [invoice.observation, [Validators.maxLength(250)]],
        swBlock: [invoice.swBlock],
        enterpriseSwIcaSelfRetainer: [invoice.enterpriseSwIcaSelfRetainer],
        purchaseOrder: [invoice.purchaseOrder, [Validators.maxLength(20)]],
        approvalNumber: [invoice.approvalNumber, [Validators.maxLength(20)]],
        remission: [invoice.remission, [Validators.maxLength(20)]]
      });

      this.formInvoiceFooter = this.formBuilder.group({
        ivaTypeId: [invoice.ivaTypeId],
        administrationRate: [invoice.administrationRate],
        incidentalRate: [invoice.incidentalRate],
        utilityRate: [invoice.utilityRate],
        debitNotesValue: [invoice.debitNotesValue, [Validators.min(0), Validators.max(99999999999.99)]],
        creditNotesValue: [invoice.creditNotesValue, [Validators.min(0), Validators.max(99999999999.99)]],
        paymentValue: [invoice.paymentValue, [Validators.min(0), Validators.max(99999999999.99)]],
        residueValue: [invoice.residueValue, [Validators.min(0), Validators.max(99999999999.99)]],
        subtotalValue: [invoice.subtotalValue, [Validators.min(0), Validators.max(99999999999.99)]],
        discountValue: [invoice.discountValue, [Validators.min(0), Validators.max(99999999999.99)]],
        ivaValue: [invoice.ivaValue, [Validators.min(0), Validators.max(99999999999.99)]],
        totalValue: [invoice.totalValue, [Validators.min(0), Validators.max(99999999999.99)]],
        reteIvaValue: [invoice.reteIvaValue, [Validators.min(0), Validators.max(99999999999.99)]],
        reteFuenteValue: [invoice.reteFuenteValue, [Validators.min(0), Validators.max(99999999999.99)]],
        reteIcaValue: [invoice.reteIcaValue, [Validators.min(0), Validators.max(99999999999.99)]],
        valueToPay: [invoice.valueToPay, [Validators.min(0), Validators.max(99999999999.99)]]
      });

      if (invoice.invoiceId != 0) {
        this.setClient(invoice.clientId);
        this.getDetailsInvoiceWithPagination();
        this.getCostCenter(invoice.costCenterId, false);
        this.getEnterprise(invoice.enterpriseId, false);
        this.getSalesRemissionsByInvoiceId(invoice.invoiceId);
        this.getInvoicingCutoffCode(invoice.invoicingCutoffId);
        this.getBussinessDocumentsType(invoice.bussinessDocumentsTypeId, false);
        this.getElectronicInvoiceInterfaceCode(invoice.electronicInvoiceInterfaceId);
      }
      this.updateFormState();
      this.setInputsForModal();
      this.getDefaultStoreForBranch(this.branchId);

      this.valueToPay = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
      }).format(invoice.valueToPay);

      setTimeout(() => this.formInvoiceFirst.controls["swBlock"].enable());
      resolve(true);
    });
  }

  visiblePreview(visible: boolean) {
    this.visibleLoading = !visible;
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }
}
